import {
  PROJECT_DEVICES_FETCH_STARTED,
  PROJECT_DEVICES_FETCH_SUCCEEDED,
  PROJECT_DEVICES_FETCH_FAILED,
  PROJECT_DEVICES_CHANGE_ORDER_AND_ORDER_BY,
  PROJECT_DEVICES_CHANGE_PAGE,
  PROJECT_DEVICES_SET_DEVICE_TYPE,
  PROJECT_DEVICES_SET_FILTER
} from '#action/types';
import { webPortalApi } from '#config/web-portal-api';
import { snackBarError } from '#action/fetch';
import { getRequestOptions } from '#helper';

let abortController = new AbortController();

export const fetchUserDevices = (projectId, exclude, editForm, data = {}) =>
  async (dispatch, getState) => {
    try {
      const {
        page,
        itemsPerPage,
        order,
        orderBy,
        deviceType,
        filter,
        filterBy
      } = getState().projectDevicesPopup;
      const { userId } = data;

      if (!userId) {
        dispatch(
          snackBarError({
            message: 'userId is required'
          })
        );

        return;
      }

      abortController.abort();
      abortController = new AbortController();
      const { signal } = abortController;

      dispatch({
        type: PROJECT_DEVICES_FETCH_STARTED
      });

      const limit = itemsPerPage;
      const offset = (page - 1) * itemsPerPage;
      const searchParams = new URLSearchParams({
        order,
        orderBy,
        offset,
        limit
      });

      if (deviceType) {
        if (deviceType.value === 'All types') {
          searchParams.delete('types');
        } else {
          searchParams.set('types', deviceType.value);
        }
      }

      if (filter && typeof filter === 'string') {
        searchParams.set('filterBy', filterBy);
        searchParams.set('filter', filter);
      }

      // Debounce to do not send multiple requests in short time
      await new Promise(res => {
        setTimeout(() => {
          res();
        }, 200);
      });

      const url = webPortalApi.buildApiUrl(`user/${userId}/device?${searchParams.toString()}`);
      const res = await fetch(url, { ...getRequestOptions(), signal });

      const contentType = res.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        throw new TypeError('Response is not json');
      }
      if (!res.ok) {
        dispatch(
          snackBarError({
            message: 'Error in request'
          })
        );
      }

      const { devices, last } = await res.json();

      const actionPayload = {
        type: PROJECT_DEVICES_FETCH_SUCCEEDED,
        payload: {
          devices,
          formData: [],
          projects: [],
          exclude,
          withDisabledBy: true
        },
        totalCount: last
      };

      dispatch(actionPayload);
    } catch (e) {
      if (e.name === 'AbortError') {
        return;
      }
      dispatch({
        type: PROJECT_DEVICES_FETCH_FAILED,
        error: e
      });
    }
  };

export const changeOrderAndOrderBy = (
  newOrder,
  newOrderBy,
  projectId,
  addMode,
  editForm,
  data
) => dispatch => {
  dispatch({
    type: PROJECT_DEVICES_CHANGE_ORDER_AND_ORDER_BY,
    payload: { order: newOrder, orderBy: newOrderBy }
  });
  dispatch(fetchUserDevices(projectId, addMode, editForm, data));
};

export const changePage = (
  newPage,
  projectId,
  addMode,
  editForm,
  data
) => dispatch => {
  dispatch({
    type: PROJECT_DEVICES_CHANGE_PAGE,
    payload: newPage
  });

  dispatch(fetchUserDevices(projectId, addMode, editForm, data));
};

export const setFilter = (newFilter, projectId, addMode, editForm, data) => dispatch => {
  dispatch({
    type: PROJECT_DEVICES_SET_FILTER,
    payload: newFilter
  });

  dispatch(fetchUserDevices(projectId, addMode, editForm, data));
};

export const setDeviceType = (
  newType,
  projectId,
  addMode,
  openedFromCreateForm,
  data
) => dispatch => {
  dispatch({
    type: PROJECT_DEVICES_SET_DEVICE_TYPE,
    payload: newType
  });

  dispatch({
    type: PROJECT_DEVICES_CHANGE_PAGE,
    payload: 1
  });

  dispatch(fetchUserDevices(projectId, addMode, openedFromCreateForm, data));
};
